import React from 'react';
import { spacing } from '../utils/designTokens';

/**
 * StatsBar - Container for page-level entity counts and metadata
 * Displays as a single pill-shaped bar containing multiple stats with separators
 * Non-interactive, visually distinct from KPIPills
 */
const StatsBar = ({ children }) => {
  if (!children) throw new Error('StatsBar requires children');

  const childArray = React.Children.toArray(children);

  return (
    <div className={`inline-flex items-center bg-background-secondary border border-border-subtle rounded-full px-3 py-1`}>
      {childArray.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < childArray.length - 1 && (
            <div className="h-3 w-px bg-border-subtle mx-2" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StatsBar;
